import {Directive, HostListener} from '@angular/core';
import {Router} from "@angular/router";

@Directive({
  selector: '[interceptRouterLink]',
  standalone: false,
})
export class InterceptRouterLinkDirective {
  constructor(private router: Router) {}

  @HostListener('click', ['$event'])
  public onClick(e: MouseEvent): void {
    const srcElem = e.srcElement;

    if (srcElem instanceof HTMLAnchorElement) {
      const routerlink = srcElem.getAttribute('routerlink');
      if (!!routerlink) {
        e.preventDefault();
        e.stopPropagation();
        this.router.navigate([routerlink]);
      }
    }
  }
}